// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"8":"22ec791b54fa185632a9","226":"9dea04bee1c30778cdab","534":"56c34c2a609712cb6f6c"}[chunkId] + ".js";
};